












import { Component, Prop, Vue } from 'vue-property-decorator';

import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({ components: { NewTranslation } })
export default class TransferredTaxcardEntry extends Vue {
  @Prop({})
  transfer!: any;

  @Prop(String)
  taxId!: string;
}
